import { ApiBase } from '../apiBase';

export class ApiDailyControlBase extends ApiBase {
  public static get baseUrl(): string {
    return '/daily_control';
  }
}
